import { storeFreeze } from 'ngrx-store-freeze';
import * as fromAuth from '../auth/store/auth.reducer';
import * as fromApprover from '../auth/store/approver/approver-auth.reducer';
import * as fromSearcher from '../auth/store/searcher/searcher-auth.reducer';
import * as fromResidentProfile from './store/resident-profile/resident-profile.reducer';
import * as fromUi from './store/ui/ui.reducer';
import * as fromLot from './store/lot/lot.reducer';

import { environment } from '../../environments/environment';

export const reducers = {
  auth: fromAuth.authReducer,
  approverAuth: fromApprover.approverAuthReducer,
  searcherAuth: fromSearcher.SearcherAuthReducer,
  ui: fromUi.UiReducer,
  residentProfile: fromResidentProfile.residentProfileReducer,
  lot: fromLot.lotReducer
};

export const metaReducers = !environment.production ? [storeFreeze] : [];
